export interface Article {
  id: string;
  title: string;
  slug: string;
  category: string;
  categoryName: string;
  summary: string;
  content: string;
  coverImage: string;
  duration: string;
  quality: string;
  releaseDate: string;
  director: string;
  cast: string[];
  views: number;
  rating: number;
  tags: string[];
  featured: boolean;
}

export const articles: Article[] = [
  {
    id: '1',
    title: '暗夜追踪',
    slug: 'anye-zhuizong',
    category: 'dongzuo',
    categoryName: '动作片',
    summary: '一名退役特种兵在都市暗夜中追踪神秘犯罪组织，展开一场惊心动魄的正义之战。高燃打斗场面与紧凑剧情完美融合，带给你肾上腺素飙升的观影体验。',
    content: `<p>《暗夜追踪》是91制片厂2024年度重磅推出的原创动作大片。影片讲述了一位名叫陆锋的退役特种兵，在繁华都市的夜幕下意外卷入一场跨国犯罪阴谋的故事。</p>
    <p>陆锋曾是特种部队的精英战士，退役后选择在都市中过着低调平静的生活。然而，一次偶然的见义勇为让他发现了一个隐藏在暗处的庞大犯罪网络。这个组织利用高科技手段进行非法交易，已经渗透到城市的各个角落。</p>
    <p>面对强大的敌人，陆锋不得不重新拾起战斗的技能。从摩天大楼的天台追逐到地下停车场的近身格斗，从高速公路的飙车激战到港口的终极对决，每一场打斗都经过精心设计，力求给观众带来最真实、最震撼的视觉冲击。</p>
    <p>影片不仅有令人血脉偾张的动作场面，更深入探讨了正义与牺牲、个人与社会的深刻主题。陆锋在追踪罪犯的过程中，也逐渐找回了自己作为军人的使命和荣耀。</p>
    <p>导演张力采用实景拍摄与特效结合的手法，将都市夜景的冷峻与动作场面的火爆完美融合。影片配乐由知名作曲家亲自操刀，电子乐与管弦乐的碰撞营造出独特的视听风格。</p>`,
    coverImage: 'https://readdy.ai/api/search-image?query=Dark%20urban%20night%20scene%20with%20silhouette%20of%20a%20man%20in%20tactical%20gear%20standing%20on%20rooftop%2C%20neon%20city%20lights%20reflecting%20in%20rain%20puddles%2C%20cinematic%20film%20poster%20style%2C%20dramatic%20lighting%2C%20film%20grain%20texture%2C%20dark%20moody%20atmosphere%2C%20professional%20movie%20poster%20photography&width=800&height=1120&seq=article-01&orientation=portrait',
    duration: '118分钟',
    quality: '4K超清',
    releaseDate: '2024-03-15',
    director: '张力',
    cast: ['陈昊', '李雪儿', '王志刚', '刘明辉'],
    views: 1280000,
    rating: 9.2,
    tags: ['动作', '犯罪', '悬疑', '都市'],
    featured: true,
  },
  {
    id: '2',
    title: '山河故人',
    slug: 'shanhe-guren',
    category: 'juqing',
    categoryName: '剧情片',
    summary: '跨越三十年的情感史诗，三代人的命运交织。从黄土高原到繁华都市，一曲关于家国情怀与个人命运的动人乐章。',
    content: `<p>《山河故人》是一部横跨三十年的家庭史诗剧情片，由91制片厂倾力打造。影片以山西一座小城为起点，讲述了一个普通家庭在时代洪流中的悲欢离合。</p>
    <p>故事从1980年代开始，年轻的赵明远怀揣梦想离开家乡，前往大城市打拼。他的妻子林秀芝留守故土，独自抚养孩子。三十年间，中国社会经历了翻天覆地的变化，这个家庭也经历了分离、重逢、误解与和解。</p>
    <p>影片通过细腻的镜头语言，展现了黄土高原的壮美风光与城市丛林的冰冷对比。导演用诗意的叙事手法，将个人命运与国家发展紧密相连，让观众在感动中思考家庭、传统与现代的关系。</p>
    <p>主演阵容汇集了国内实力派演员，精湛的表演将角色的内心世界刻画得淋漓尽致。影片配乐采用山西民乐元素与现代交响乐的融合，营造出独特的视听美学。</p>`,
    coverImage: 'https://readdy.ai/api/search-image?query=Cinematic%20film%20poster%20of%20a%20family%20standing%20on%20loess%20plateau%20landscape%20at%20sunset%2C%20traditional%20Chinese%20village%20in%20distance%2C%20warm%20golden%20hour%20light%2C%20nostalgic%20atmosphere%2C%20film%20grain%2C%20professional%20movie%20poster%20photography%2C%20poetic%20composition&width=800&height=1120&seq=article-02&orientation=portrait',
    duration: '142分钟',
    quality: '4K超清',
    releaseDate: '2024-01-20',
    director: '林雨',
    cast: ['赵文轩', '孙俪华', '王磊', '张静初'],
    views: 980000,
    rating: 9.5,
    tags: ['剧情', '家庭', '时代', '史诗'],
    featured: true,
  },
  {
    id: '3',
    title: '极地密码',
    slug: 'jidi-mima',
    category: 'jilupian',
    categoryName: '纪录片',
    summary: '跟随科考队深入南极腹地，揭开冰封大陆下隐藏的远古秘密。前所未有的极地探险纪录片，带你领略地球最后的净土。',
    content: `<p>《极地密码》是91制片厂历时三年打造的大型自然探索纪录片。摄制组跟随中国第38次南极科考队，深入南极大陆腹地，记录下这片冰封大陆的壮美与神秘。</p>
    <p>影片采用8K超高清摄影技术，首次全方位展现了南极冰盖下的神秘世界。从巨大的冰裂缝到深邃的冰下湖泊，从可爱的帝企鹅到神秘的冰虫生物，每一个画面都令人叹为观止。</p>
    <p>纪录片不仅呈现了极地的自然奇观，更深入探讨了气候变化对南极生态的影响。科学家们在极端环境下的研究工作和日常生活，也让观众感受到人类探索未知的勇气和智慧。</p>
    <p>配音由著名配音演员担纲，配乐由好莱坞作曲家创作，宏大的交响乐与极地的壮美风光相得益彰，营造出震撼心灵的视听体验。</p>`,
    coverImage: 'https://readdy.ai/api/search-image?query=Stunning%20Antarctic%20ice%20landscape%20with%20research%20station%20and%20aurora%20borealis%20in%20night%20sky%2C%20dramatic%20polar%20scenery%2C%20penguins%20on%20ice%2C%20cinematic%20documentary%20poster%20style%2C%20cold%20blue%20and%20white%20tones%2C%20professional%20film%20poster&width=800&height=1120&seq=article-03&orientation=portrait',
    duration: '96分钟',
    quality: '8K超清',
    releaseDate: '2024-02-10',
    director: '陈远航',
    cast: ['旁白：季冠霖'],
    views: 560000,
    rating: 9.7,
    tags: ['纪录片', '自然', '南极', '探险'],
    featured: true,
  },
  {
    id: '4',
    title: '欢乐合伙人',
    slug: 'huanle-hehuoren',
    category: 'xiju',
    categoryName: '喜剧片',
    summary: '三个性格迥异的年轻人合伙创业，闹出一连串啼笑皆非的故事。笑中带泪的都市喜剧，献给每一个奋斗中的你。',
    content: `<p>《欢乐合伙人》是一部轻松诙谐的都市喜剧，讲述了三个大学好友——理想主义的程序员阿杰、精打细算的会计小美和天马行空的设计师大鹏——合伙创办一家创意公司的故事。</p>
    <p>三人怀揣着改变世界的梦想，却在创业路上遇到了各种啼笑皆非的挑战：奇葩客户的离谱需求、投资人的刁钻问题、办公室里的鸡毛蒜皮……每一个困难都被他们用独特的方式化解，过程中充满了令人捧腹的桥段。</p>
    <p>但喜剧的背后，是对当代年轻人创业现状的真实写照。影片在欢笑中融入了对友情、梦想和坚持的思考，让观众在开怀大笑的同时也能感受到温暖和力量。</p>
    <p>三位主演的化学反应极佳，即兴发挥的桥段层出不穷。导演采用轻松明快的叙事节奏，配合活泼的配乐，营造出独特的喜剧氛围。</p>`,
    coverImage: 'https://readdy.ai/api/search-image?query=Three%20young%20Chinese%20friends%20laughing%20together%20in%20a%20modern%20creative%20office%20space%2C%20bright%20and%20cheerful%20atmosphere%2C%20colorful%20decor%2C%20comedy%20film%20poster%20style%2C%20warm%20lighting%2C%20fun%20and%20energetic%20mood&width=800&height=1120&seq=article-04&orientation=portrait',
    duration: '105分钟',
    quality: '4K超清',
    releaseDate: '2024-04-01',
    director: '马小跳',
    cast: ['彭昱畅', '关晓彤', '魏大勋'],
    views: 2100000,
    rating: 8.9,
    tags: ['喜剧', '创业', '友情', '都市'],
    featured: true,
  },
  {
    id: '5',
    title: '第七层',
    slug: 'diqiceng',
    category: 'xuanyi',
    categoryName: '悬疑片',
    summary: '一栋神秘的大楼，七层地上对应七层地下。当一个失踪案件揭开大楼的秘密，真相远比想象中更加扑朔迷离。',
    content: `<p>《第七层》是91制片厂出品的原创悬疑烧脑大片。故事发生在一栋名为"天境大厦"的神秘建筑中，这栋大楼表面上有七层，但传言地下还有对应的七层秘密空间。</p>
    <p>刑警队长周然接手了一起离奇的失踪案件，失踪者是大厦的一名普通职员。随着调查的深入，周然发现这栋大楼隐藏着惊人的秘密——每一层地下空间都对应着不同的时间线，而失踪者似乎拥有了穿越时空的能力。</p>
    <p>影片采用非线性叙事手法，将多条时间线巧妙交织。观众需要跟随主角的视角，在碎片化的线索中拼凑出完整的真相。每一个细节都可能是关键，每一个反转都出人意料。</p>
    <p>导演采用独特的视觉风格，用冷暖色调的对比来区分不同的时空层次。配乐由电子音乐人创作，营造出迷离梦幻的悬疑氛围。</p>`,
    coverImage: 'https://readdy.ai/api/search-image?query=Mysterious%20modern%20skyscraper%20with%20geometric%20shadows%20and%20fog%2C%20film%20noir%20aesthetic%2C%20thriller%20movie%20poster%20style%2C%20dark%20and%20moody%20atmosphere%2C%20red%20accent%20lighting%2C%20professional%20cinematic%20photography%2C%20suspenseful%20tone&width=800&height=1120&seq=article-05&orientation=portrait',
    duration: '128分钟',
    quality: '4K超清',
    releaseDate: '2024-05-20',
    director: '韩冷',
    cast: ['朱一龙', '倪妮', '王传君'],
    views: 1850000,
    rating: 9.0,
    tags: ['悬疑', '科幻', '烧脑', '犯罪'],
    featured: true,
  },
  {
    id: '6',
    title: '星际漂流',
    slug: 'xingji-piaoliu',
    category: 'kehuan',
    categoryName: '科幻片',
    summary: '公元2157年，人类殖民舰队在深空遭遇未知文明。一场关乎人类命运的星际冒险，揭开宇宙最深处的终极秘密。',
    content: `<p>《星际漂流》是91制片厂投资最大的科幻巨制，由国际顶尖视效团队耗时两年打造。影片设定在公元2157年，人类已经开启了星际殖民时代。</p>
    <p>"黎明号"殖民舰队在执行深空探索任务时，意外接收到一组神秘信号。舰队指挥官叶辰决定追踪信号来源，却意外发现了一个远超人类文明的外星遗迹。这个遗迹中隐藏着关于宇宙起源的终极秘密，也引来了未知文明的觊觎。</p>
    <p>影片构建了一个宏大而严谨的科幻世界观，从太空舰船的设计到外星文明的设定，每一个细节都经过科学顾问的精心推敲。视觉效果方面，影片采用了最新的虚拟制片技术，打造出令人叹为观止的太空场景。</p>
    <p>影片不仅有震撼的视觉奇观，更深入探讨了人类在宇宙中的位置、文明的冲突与共存等深刻主题。主演的表演将角色的勇气、迷茫与成长展现得淋漓尽致。</p>`,
    coverImage: 'https://readdy.ai/api/search-image?query=Epic%20sci-fi%20spaceship%20approaching%20a%20massive%20alien%20structure%20near%20a%20nebula%2C%20cinematic%20space%20scene%2C%20professional%20movie%20poster%2C%20deep%20space%20with%20stars%2C%20futuristic%20design%2C%20dramatic%20lighting%2C%20warm%20and%20cool%20color%20contrast&width=800&height=1120&seq=article-06&orientation=portrait',
    duration: '155分钟',
    quality: '4K超清 IMAX',
    releaseDate: '2024-06-15',
    director: '郭凡',
    cast: ['吴京', '刘浩存', '张译', '李雪健'],
    views: 3200000,
    rating: 9.4,
    tags: ['科幻', '太空', '冒险', '外星文明'],
    featured: true,
  },
  {
    id: '7',
    title: '春风十里',
    slug: 'chunfeng-shili',
    category: 'aiqing',
    categoryName: '爱情片',
    summary: '两个错过的灵魂，在最美的季节重逢。一段跨越十年的纯爱故事，温暖你的整个春天。',
    content: `<p>《春风十里》是一部唯美浪漫的爱情电影，讲述了青梅竹马的林凡和苏瑾在分别十年后重逢的故事。</p>
    <p>十年前，林凡和苏瑾是高中同学，彼此暗恋却从未表白。高考后各奔东西，林凡去了北京，苏瑾留在家乡。十年后的春天，两人在一场同学聚会上再次相遇，尘封的感情被重新唤醒。</p>
    <p>然而，十年的时光改变了太多。林凡已经订婚，苏瑾也有了稳定的感情。两人在现实与情感的拉扯中，重新审视自己的人生选择和内心真正的渴望。</p>
    <p>导演以细腻唯美的镜头语言，捕捉了江南春天的每一寸美好——樱花树下的邂逅、细雨中的漫步、黄昏时的对视。影片配乐以钢琴和弦乐为主，营造出温柔浪漫的氛围。</p>`,
    coverImage: 'https://readdy.ai/api/search-image?query=Romantic%20Chinese%20couple%20under%20cherry%20blossom%20trees%20in%20spring%2C%20soft%20pastel%20colors%2C%20dreamy%20atmosphere%2C%20romance%20film%20poster%20style%2C%20gentle%20sunlight%20through%20petals%2C%20emotional%20and%20tender%20mood%2C%20cinematic%20photography&width=800&height=1120&seq=article-07&orientation=portrait',
    duration: '112分钟',
    quality: '4K超清',
    releaseDate: '2024-02-14',
    director: '李晓雨',
    cast: ['刘昊然', '周也', '陈飞宇'],
    views: 1560000,
    rating: 8.7,
    tags: ['爱情', '青春', '重逢', '唯美'],
    featured: false,
  },
  {
    id: '8',
    title: '镜中人',
    slug: 'jingzhongren',
    category: 'kongbu',
    categoryName: '恐怖片',
    summary: '一面古老的铜镜，映照出人心最深处的恐惧。当镜中的倒影开始拥有自己的意志，谁才是真正的你？',
    content: `<p>《镜中人》是91制片厂出品的心理恐怖佳作，以独特的东方恐怖美学征服了无数观众。影片围绕一面拥有神秘力量的古代铜镜展开。</p>
    <p>古董收藏家苏婉在一次拍卖会上购得一面宋代的铜镜。从那天起，她开始注意到镜中的倒影偶尔会做出与她不同的动作。起初她以为只是幻觉，但随着时间推移，镜中的"她"变得越来越活跃，甚至开始影响现实世界。</p>
    <p>苏婉求助于民俗学者，发现这面铜镜曾是古代祭祀用的法器，镜中封印着一个古老的怨灵。而更可怕的是，镜中的倒影正在一步步取代现实中的她。</p>
    <p>影片巧妙地运用了中国传统恐怖元素，没有依赖跳跃式惊吓，而是通过氛围营造和心理暗示让恐惧慢慢渗透。导演对光影的运用堪称一绝，每一面镜子都可能成为恐惧的来源。</p>`,
    coverImage: 'https://readdy.ai/api/search-image?query=Eerie%20antique%20Chinese%20bronze%20mirror%20reflecting%20a%20ghostly%20face%2C%20dark%20room%20with%20candlelight%2C%20horror%20film%20poster%20style%2C%20atmospheric%20and%20haunting%2C%20traditional%20Chinese%20horror%20aesthetic%2C%20professional%20cinematic%20photography&width=800&height=1120&seq=article-08&orientation=portrait',
    duration: '98分钟',
    quality: '4K超清',
    releaseDate: '2024-07-10',
    director: '温子仁(监制)',
    cast: ['马思纯', '张子枫', '王砚辉'],
    views: 890000,
    rating: 8.5,
    tags: ['恐怖', '心理', '东方', '惊悚'],
    featured: false,
  },
  {
    id: '9',
    title: '铁拳雄心',
    slug: 'tiequan-xiongxin',
    category: 'dongzuo',
    categoryName: '动作片',
    summary: '地下拳场的无名拳手，为了守护所爱之人，一路过关斩将，用铁拳打出属于自己的荣耀之路。',
    content: `<p>《铁拳雄心》是一部热血沸腾的动作片，讲述了一个关于勇气、尊严和救赎的故事。主角阿虎是一名在地下拳场谋生的拳手，生活困苦但从不放弃。</p>
    <p>当阿虎的妹妹患上重病急需手术费时，他不得不参加一场危险的地下拳王争霸赛。面对强大的对手和黑暗的势力，阿虎用他的铁拳和钢铁意志一路拼搏。</p>
    <p>影片的格斗场面全部由专业武术指导设计，融合了拳击、散打和综合格斗的元素。主演在拍摄前接受了长达四个月的格斗训练，所有打斗场景均亲自上阵。</p>
    <p>除了激烈的动作场面，影片还深入描绘了底层人物的生活状态和兄弟情谊。每一个角色都有血有肉，让观众在热血之余也能感受到人性的温度。</p>`,
    coverImage: 'https://readdy.ai/api/search-image?query=Muscular%20fighter%20in%20boxing%20ring%20with%20dramatic%20overhead%20lighting%2C%20sweat%20and%20intensity%2C%20action%20film%20poster%20style%2C%20dark%20background%20with%20spotlight%2C%20cinematic%20sports%20photography%2C%20powerful%20and%20dramatic%20mood&width=800&height=1120&seq=article-09&orientation=portrait',
    duration: '110分钟',
    quality: '4K超清',
    releaseDate: '2024-04-28',
    director: '陈德森',
    cast: ['张晋', '托尼·贾', '任达华'],
    views: 1750000,
    rating: 8.8,
    tags: ['动作', '格斗', '热血', '兄弟情'],
    featured: true,
  },
  {
    id: '10',
    title: '岁月如歌',
    slug: 'suiyue-ruge',
    category: 'juqing',
    categoryName: '剧情片',
    summary: '一位老音乐人回顾自己跌宕起伏的一生，在旋律中寻找生命的真谛。献给所有热爱音乐和生活的灵魂。',
    content: `<p>《岁月如歌》是一部以音乐为主题的剧情片，讲述了老音乐人顾怀瑾的一生。影片以倒叙的方式，从顾怀瑾在养老院度过80岁生日开始，回顾了他与音乐相伴的一生。</p>
    <p>从少年时期在弄堂里第一次听到小提琴的声音，到青年时期在音乐学院的热血岁月；从文革时期的艰难坚守，到改革开放后的创作高峰。顾怀瑾的一生就是一部中国现代音乐史的缩影。</p>
    <p>影片中穿插了大量原创音乐作品，融合了古典音乐与中国传统音乐的元素。主演为了塑造角色，特意学习了三个月的钢琴和小提琴演奏，片中的演奏场景全部实拍。</p>
    <p>影片不仅是对一位音乐人的致敬，更是对一个时代的深情回望。在动人的旋律中，观众将感受到艺术的力量和生命的韧性。</p>`,
    coverImage: 'https://readdy.ai/api/search-image?query=Elderly%20Chinese%20musician%20playing%20violin%20in%20a%20warm%20sunlit%20room%20filled%20with%20old%20photos%20and%20music%20sheets%2C%20nostalgic%20atmosphere%2C%20golden%20hour%20light%2C%20drama%20film%20poster%20style%2C%20emotional%20and%20touching%20mood&width=800&height=1120&seq=article-10&orientation=portrait',
    duration: '135分钟',
    quality: '4K超清',
    releaseDate: '2024-08-30',
    director: '张艺谋(艺术顾问)',
    cast: ['陈道明', '巩俐', '黄渤', '周迅'],
    views: 760000,
    rating: 9.6,
    tags: ['剧情', '音乐', '人生', '艺术'],
    featured: false,
  },
  {
    id: '11',
    title: '迷雾岛',
    slug: 'miwu-dao',
    category: 'xuanyi',
    categoryName: '悬疑片',
    summary: '十位陌生人被困孤岛，一场死亡游戏悄然展开。谁能活着离开迷雾岛？真相永远出乎意料。',
    content: `<p>《迷雾岛》改编自畅销悬疑小说，采用经典的暴风雪山庄模式，但融入了更多现代悬疑元素。十位来自不同行业的陌生人收到神秘邀请函，来到一座与世隔绝的私人岛屿。</p>
    <p>登岛后，他们发现岛上的豪华别墅中空无一人，但一切都布置得井井有条。更诡异的是，每个人都在别墅中发现了一件与自己过去密切相关的物品。当第一个人离奇死亡后，恐慌开始蔓延。</p>
    <p>每个人都可能是凶手，每个人也都可能是下一个目标。随着死亡人数的增加，幸存者们开始互相猜疑，而岛上隐藏的秘密也逐渐浮出水面。</p>
    <p>影片节奏紧凑，反转不断，每一个角色都有着不为人知的过去。导演巧妙地运用了岛屿的封闭环境，营造出无处可逃的压抑感和紧张氛围。</p>`,
    coverImage: 'https://readdy.ai/api/search-image?query=Mysterious%20foggy%20island%20with%20a%20grand%20mansion%20silhouette%2C%20dark%20stormy%20sky%2C%20thriller%20film%20poster%20style%2C%20atmospheric%20and%20suspenseful%2C%20cinematic%20mystery%20aesthetic%2C%20professional%20movie%20poster%20photography&width=800&height=1120&seq=article-11&orientation=portrait',
    duration: '108分钟',
    quality: '4K超清',
    releaseDate: '2024-09-15',
    director: '陈思诚',
    cast: ['刘德华', '肖央', '谭卓', '文咏珊'],
    views: 950000,
    rating: 8.6,
    tags: ['悬疑', '惊悚', '孤岛', '推理'],
    featured: false,
  },
  {
    id: '12',
    title: '动物王国',
    slug: 'dongwu-wangguo',
    category: 'jilupian',
    categoryName: '纪录片',
    summary: '深入中国最偏远的自然保护区，记录珍稀野生动物的真实生活。一部关于生命、自然与和谐的视觉史诗。',
    content: `<p>《动物王国》是91制片厂联合国家地理频道打造的自然纪录片巨制，摄制组历时五年，深入中国15个国家级自然保护区，记录下最珍贵的野生动物影像。</p>
    <p>从青藏高原的雪豹到云南热带雨林的亚洲象，从东北虎到长江江豚，影片首次以4K超高清画质呈现了中国丰富的生物多样性。每一个镜头都凝聚了摄影师数月甚至数年的等待和坚守。</p>
    <p>纪录片不仅展示了动物们的生存状态，更讲述了一个个动人的生命故事——母雪豹独自抚养幼崽的艰辛、丹顶鹤伴侣的忠贞不渝、金丝猴家族的权力更迭。</p>
    <p>影片配乐由谭盾创作，将中国传统乐器与交响乐完美融合，为观众带来一场视听盛宴。中文旁白由濮存昕担任，英文版由大卫·爱登堡配音。</p>`,
    coverImage: 'https://readdy.ai/api/search-image?query=Majestic%20snow%20leopard%20in%20Tibetan%20plateau%20with%20snowy%20mountains%20background%2C%20wildlife%20documentary%20poster%20style%2C%20natural%20light%2C%20professional%20nature%20photography%2C%20cinematic%20composition%2C%20pristine%20wilderness&width=800&height=1120&seq=article-12&orientation=portrait',
    duration: '90分钟',
    quality: '4K超清',
    releaseDate: '2024-10-01',
    director: '陆川',
    cast: ['旁白：濮存昕'],
    views: 420000,
    rating: 9.8,
    tags: ['纪录片', '自然', '动物', '中国'],
    featured: false,
  },
];

export const getArticleById = (id: string) => {
  return articles.find((a) => a.id === id);
};

export const getArticlesByCategory = (categorySlug: string) => {
  return articles.filter((a) => a.category === categorySlug);
};

export const getFeaturedArticles = () => {
  return articles.filter((a) => a.featured);
};

export const getRelatedArticles = (article: Article, limit: number = 4) => {
  return articles
    .filter((a) => a.id !== article.id && a.category === article.category)
    .slice(0, limit);
};